/**
 * App layout component
 * Main layout wrapper with sidebar, header, and content area
 */

import { useEffect } from 'react';
import { Layout, ConfigProvider } from 'antd';
import { Outlet, useLocation } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { ToastProvider } from '@/components/common/ToastProvider';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { lightTheme, darkTheme } from '@/styles/theme';
import { usePreferencesStore } from '@/stores/usePreferencesStore';

const { Content } = Layout;

const SIDEBAR_WIDTH = 240;

export function AppLayout() {
  const location = useLocation();
  const { theme } = usePreferencesStore();
  const isDarkMode = theme === 'dark';

  const currentTheme = isDarkMode ? darkTheme : lightTheme;

  // Apply theme class to document
  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
  }, [theme]);

  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <ConfigProvider theme={currentTheme}>
      <Layout style={{ minHeight: '100vh' }}>
        <Sidebar />

        <Layout
          style={{
            marginLeft: SIDEBAR_WIDTH,
          }}
        >
          <Header />

          <Content
            style={{
              margin: 24,
              padding: 24,
              background: isDarkMode ? '#141414' : '#fff',
              borderRadius: 8,
              minHeight: 'calc(100vh - 64px - 48px)',
            }}
          >
            <ErrorBoundary showDetails={import.meta.env.DEV}>
              <Outlet />
            </ErrorBoundary>
          </Content>
        </Layout>
      </Layout>

      {/* Toast notifications */}
      <ToastProvider />
    </ConfigProvider>
  );
}

export default AppLayout;
